import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useAuthStore } from '@/store/auth'
import { getAvatarInitials } from '@/utils/user'
import { Link } from '@tanstack/react-router'
import { LogOut, Settings, User } from 'lucide-react'

const ProfileDropdown = () => {
  const user = useAuthStore((s) => s.user)
  const signOut = useAuthStore((s) => s.signOut)

  const handleLogout = async () => {
    signOut({
      redirectUrl: window.location.origin,
    })
  }

  if (!user) {
    return (
      <Avatar className="opacity-70 cursor-not-allowed">
        <AvatarFallback>
          <User className="w-4 h-4" />
        </AvatarFallback>
      </Avatar>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="rounded-full cursor-pointer">
        <div>
          <Avatar>
            <AvatarImage src={user.avatar_url} alt="Profile Picture" />
            <AvatarFallback>
              {getAvatarInitials({
                firstName: user.first_name,
                email: user.email,
              })}
            </AvatarFallback>
          </Avatar>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem asChild>
          <Link to="/settings">
            <Settings className="w-4 h-4" />
            <span className="ml-2">Settings</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout}>
          <LogOut className="w-4 h-4 text-destructive sm:w-6 sm:h-6" />
          <span className="ml-2">Sign out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ProfileDropdown
